module.exports = __webpack_public_path__ + "img/L_302_362.461daa3e.png";